var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8636_18760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 45C35.4263 45 45.4999 34.9264 45.4999 22.5C45.4999 10.0736 35.4263 0 22.9999 0C10.5735 0 0.499878 10.0736 0.499878 22.5C0.499878 34.9264 10.5735 45 22.9999 45Z",
    fill: "#1677F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1753 35.0005V24.065H28.8232L29.5149 19.5443H25.1753V16.6046C25.1753 15.3694 25.7847 14.1589 27.728 14.1589H29.7043V10.3052C29.7043 10.3052 27.9092 10.0005 26.2046 10.0005C22.6308 10.0005 20.2922 12.1662 20.2922 16.0858V19.5361H16.315V24.0568H20.2922V34.9923H25.1835L25.1753 35.0005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8636_18760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.499878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon_fb.4df46db772fea900f9483c28f2aa61e9.svg";
export { ForwardRef as ReactComponent };